<template>
  <div class="h-100 relative">
    <v-progress-linear class="linear" v-show="loading" :indeterminate="true"></v-progress-linear>
    <v-tabs
      v-model="tab"
      color="white"
      slider-color="primary"
    >
      <v-tab
        key="1"
        ripple
      >
        Messages <span class="secondary--text" v-if="feedCount > 0">&nbsp({{feedCount}})</span>
      </v-tab>
      <v-tab
        key="2"
        ripple
        :disabled="isItemDisabled"
      >
        Reports <span class="secondary--text" v-if="reportCount > 0">&nbsp({{reportCount}})</span>
      </v-tab>
      <v-tab-item
        key="1"
        v-if="!loading"
      >
      <v-layout row wrap fill-height>
        <v-flex class="relative" xs12 v-if="feedback.length > 0">
          <v-list two-line >
            <template v-for="(item, index) in sortedFeedback">
              <v-list-tile
                :key="item.id"
                avatar
                ripple
                @click="openFeedback(item)"
              >
                  <v-list-tile-avatar
                    class="headline font-weight-light white--text"
                    v-if="item.sender_name"
                  >
                    <span class="secondary--text" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 50%; width: 40px; height: 40px; line-height: 40px;">{{item.sender_name.charAt(0)}}</span>
                  </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.subject }}</v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary">{{ item.created_at | calendar }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>{{ item.message | striphtml}}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <!-- <v-list-tile-action-text>{{ item.action }}</v-list-tile-action-text> -->
                  <v-icon
                    v-show="item.notifications.length > 0"
                    color="secondary"
                  >
                    announcement
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                inset
                :key="index"
              ></v-divider>
            </template>
          </v-list>
        </v-flex>
        <v-flex v-else xs12 class="text-xs-center">
          <p class="text-xs-center mt-4">
          <strong class="primary--text">
              There is no current feedback.<br> Please check back soon.
          </strong>
          </p>
        </v-flex>
      </v-layout>
      </v-tab-item>
      <v-tab-item
        key="2"
        v-if="!loading"
      >
      <v-layout row wrap fill-height>
        <v-flex class="relative" xs12 v-if="sortedReports.length > 0">


          <v-list two-line>
            <template v-for="(item, index) in sortedReports">
              <v-list-tile
                :key="item.id"
                avatar
                @click="openReport(item)"
              >
                <v-list-tile-avatar
                  class="headline font-weight-light white--text"
                >
                  <span class="secondary--text" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 50%; width: 40px; height: 40px; line-height: 40px;"><v-icon color="secondary">timeline</v-icon></span>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{  item.start_date | calendarShortUnix }} - {{ item.end_date | calendarShortUnix }}</v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.message"></v-list-tile-sub-title>
                </v-list-tile-content>
                  <v-list-tile-action>
                  <v-icon
                    v-show="!item.read_at"
                    color="secondary"
                  >
                    notification_important
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                inset
                :key="'divider-' + index"
              ></v-divider>
            </template>
          </v-list>
        </v-flex>
        <v-flex v-else xs12 class="text-xs-center">
          <p class="text-xs-center mt-4">
          <strong class="primary--text">
              You have no reports.<br> Please check back soon.
          </strong>
          </p>
        </v-flex>
      </v-layout>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="composeDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-btn fab dark small color="primary" id="compose-fab" slot="activator">
        <v-icon dark>create</v-icon>
      </v-btn>
      <v-card>
        <v-toolbar dark color="primary">
          <v-icon @click="composeDialog = false">arrow_back</v-icon>
          <v-toolbar-title>Compose</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="submitFeedback" :loading="loadingSave" :disabled="!valid">send</v-icon>
        </v-toolbar>
        <v-form ref="form" v-model="valid">
          <v-autocomplete
            v-model="recipients"
            :items="coaches"
            item-value="id"
            item-text="name"
            chips
            label="To"
            full-width
            hide-details
            hide-no-data
            hide-selected
            multiple
            single-line
          ></v-autocomplete>
          <v-divider></v-divider>
          <v-text-field
            v-model="subject"
            placeholder="subject (required)"
            single-line
            full-width
            hide-details
            :rules="[v => !!v || 'Field is required']"
            required
          ></v-text-field>
          <v-divider></v-divider>
          <v-textarea
            v-model="message"
            placeholder="Compose message (required)"
            full-width
            single-line
            auto-grow
            hide-details
            :rules="[v => !!v || 'Field is required']"
            required
          ></v-textarea>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { db } from '@/services/firebase'
export default {
  components: {
  },
  data () {
    return {
      tab: 0,
      reports: [],
      feedback: [],
      loading: false,
      loadingSave: false,
      notifications: [],
      composeDialog: false,
      steven: require('@/assets/img/steven.jpg'),
      ruth: require('@/assets/img/ruth.jpg'),
      valid: true,
      coaches: [],
      recipients: [],
      subject: '',
      message: ''
    }
  },
  mounted () {
    this.getReports()
    this.getFeedback()
    this.getCoaches()
    this.$nextTick(function () {
      this.getNotifications()
    })
  },
  methods: {
    getReports: function () {
      var self = this
      var repostsRef = db.collection('user_reports')
      repostsRef.where('user_id', '==', self.currentUser)
        .onSnapshot(function (querySnapshot) {
          if (querySnapshot.empty) {
          } else {
            querySnapshot.docChanges().forEach(function (change) {
              if (change.type === 'added') {
                var newItem = change.doc.data()
                self.$set(newItem, 'id', change.doc.id)
                self.reports.push(newItem)
              }
            })
          }
        })
    },
    getFeedback: function () {
      var self = this
      var feedbackRef = db.collection('feedback')
      feedbackRef.where('recipients', 'array-contains', self.currentUser).where('deleted_at', '==', null)
        .onSnapshot(function (querySnapshot) {
          querySnapshot.docChanges().forEach(function (change) {
            if (change.type === 'added') {
              var newItem = change.doc.data()
              self.$set(newItem, 'id', change.doc.id)
              self.$set(newItem, 'notifications', [])
              self.feedback.push(newItem)
            }
          })
        })
      feedbackRef.where('sender_id', '==', self.currentUser).where('deleted_at', '==', null)
        .onSnapshot(function (querySnapshot) {
          querySnapshot.docChanges().forEach(function (change) {
            if (change.type === 'added') {
              var newItem = change.doc.data()
              self.$set(newItem, 'notifications', [])
              self.$set(newItem, 'id', change.doc.id)
              self.feedback.push(newItem)
            }
          })
        })
    },
    getNotifications: function () {
      var self = this
      db.collection('notifications').where('user_id', '==', self.currentUser).where('read_at', '==', null)
        .onSnapshot(function (querySnapshot) {
          querySnapshot.docChanges().forEach(function (change) {
            if (change.type === 'added') {
              var newItem = change.doc.data()
              self.$set(newItem, 'id', change.doc.id)
              self.notifications.push(newItem)
              self.feedback.forEach(feed => {
                if (newItem.feedback_id === feed.id) {
                  feed.notifications.push(newItem)
                } else {
                }
              })
            }
            if (change.type === 'removed') {
              let i = self.notifications.map(item => item.id).indexOf(change.doc.id) // find index of your object
              self.notifications.splice(i, 1)
            }
          })
        })
    },
    getCoaches: function () {
      var self = this
      db.collection('users')
        .where('admin', '==', true)
        .where('active', '==', true)
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            if (self.currentUser === 'nWHYeiCXedSvpLYsKfe9h9Eqwrq1') {
              if (doc.id === 'dk6OAdACjkR51h1pjysQNOqCou92') {
                var testCoach = doc.data()
                testCoach.id = doc.id
                self.coaches.push(testCoach)
              }
            } else {
              if (doc.id !== 'dk6OAdACjkR51h1pjysQNOqCou92') {
                var data = doc.data()
                data.id = doc.id
                self.coaches.push(data)
              }
            }
          })
        })
        .catch(function (error) {
          console.log('Error getting workouts: ', error)
        })
    },
    submitFeedback: function () {
      if (this.valid) {
        this.loadingSave = true
        var self = this
        db.collection('feedback').add({
          subject: self.subject,
          message: self.message,
          created_at: moment().unix(),
          updated_at: moment().unix(),
          sender_id: self.currentUser,
          sender_name: self.userProfile.name,
          recipients: self.recipients,
          read_at: null,
          deleted_at: null
        })
          .then(function (docRef) {
            self.addNofitication(docRef.id)
          })
          .catch(function (error) {
            if (error) {
              self.loadingSave = false
              console.error('Error', error)
            }
          })
      }
    },
    addNofitication (feedbackId) {
      var self = this
      self.recipients.forEach((user, key, recipients) => {
        db.collection('notifications').add({
          created_at: moment().unix(),
          user_id: user,
          sender_id: self.currentUser,
          sender_name: self.userProfile.name,
          feedback_id: feedbackId,
          read_at: null
        })
        if (key === recipients.length - 1) {
          self.composeDialog = false
          self.loadingSave = false
          self.subject = ''
          self.message = ''
        }
      })
    },
    openFeedback: function (item) {
      this.loading = true
      if (!item.read_at) {
        this.$set(item, 'read_at', moment().unix())
        var self = this
        var statRef = db.collection('feedback').doc(item.id)
        statRef.set({
          read_at: moment().unix()
        }, { merge: true })
          .then(function () {
            self.deleteNotifications(item)
          })
          .catch(function (error) {
            console.error('Error', error)
          })
      } else {
        this.deleteNotifications(item)
      }
    },
    openReport: function (item) {
      this.loading = true
      if (!item.read_at) {
        this.$set(item, 'read_at', moment().unix())
        var self = this
        var reportRef = db.collection('user_reports').doc(item.id)
        reportRef.set({
          read_at: moment().unix()
        }, { merge: true })
          .then(function () {
            self.deleteNotificationsReport(item)
          })
          .catch(function (error) {
            console.error('Error', error)
          })
      } else {
        this.$router.push({name: 'Report Show', params: {reportId: item.id, report: item}})
      }
    },
    deleteNotificationsReport: function (item) {
      // filter notifications relavant to feedback item
      var filtered = this.notifications.filter(function (n) {
        return n.report_id === item.id
      })
      // if has notification (filtered > 0)
      if (filtered.length > 0) {
        filtered.forEach(function (n) {
          db.collection('notifications').doc(n.id).update({
            'read_at': moment().unix()
          })
            .then(function () {
            })
        })
        this.$router.push({name: 'Report Show', params: {reportId: item.id, report: item}})
      } else {
        this.$router.push({name: 'Report Show', params: {reportId: item.id, report: item}})
      }
    },
    deleteNotifications: function (item) {
      // filter notifications relavant to feedback item
      var filtered = this.notifications.filter(function (n) {
        return n.feedback_id === item.id
      })
      // if has notification (filtered > 0)
      if (filtered.length > 0) {
        filtered.forEach(function (n) {
          // To update age and favorite color:
          db.collection('notifications').doc(n.id).update({
            'read_at': moment().unix()
          })
            .then(function () {
            })
        })
        this.$router.push({name: 'Feedback Show', params: {feedbackId: item.id}})
      } else {
        this.$router.push({name: 'Feedback Show', params: {feedbackId: item.id}})
      }
    },
    hasNotification: function (item) {
      var filtered = this.notifications.filter(function (n) {
        return n.feedback_id === item.id
      })
      if (filtered.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    sortedFeedback: function () {
      if (this.feedback.length > 0) {
        // return this.feedback
        return _.orderBy(this.feedback, 'updated_at', 'desc')
      } else {
        return []
      }
    },
    sortedReports: function () {
      if (this.reports.length > 0) {
        // return this.feedback
        return _.orderBy(this.reports, 'created_at', 'desc')
      } else {
        return []
      }
    },
    feedCount () {
      var filtered = this.notifications.filter(function (n) {
        return n.feedback_id !== null
      })
      return filtered.length
    },
    reportCount () {
      var filtered = this.notifications.filter(function (n) {
        return n.report_id !== null
      })
      return filtered.length
    },
    isItemDisabled () {
      if (this.userProfile.trial) {
        return true
      }
      return false
    }
  }
}
</script>
<style scoped>
  .linear {
    position: absolute;
    top: -12px;
    z-index: 1;
  }
  #compose-fab {
    position: absolute;
    bottom: 9px;
    right: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/members/feedbackView.vue